module.exports = "SELECT st_asgeojson(the_geom),\n       cartodb_id,\n       jurisdiction\nFROM jurisdictions\nWHERE cartodb_id = '{jurisdictionId}'\n"